import template from './habit_5_report.html'
import * as Permissions from '../../lib/permission_utils.js'
import * as Utils from '../../lib/savanna_utils.js'
import tr from '../../lib/default-translator.js'

class ReportHabit5ViewModel
{
    constructor(page)
    {
        this.page = page
        this.loader = ko.observable(false)

        this.employee_habit_5_report = ko.observableArray([])
        this.all_employee_data = ko.observableArray([]) // Store all employee data
        this.current_department_id = ko.observable()
        this.selected_department = ko.observable()

        // Pagination properties
        this.current_page_number = ko.observable(1)
        this.current_page_size = ko.observable(10)
        this.page_count = ko.observable(1)
        this.pagination_summary = ko.observable('')
        this.number_of_records = ko.observableArray([10, 20, 50, 100, 200])
        this.selected_number_of_records = ko.observable(20)
        this.total_records = ko.observable(0)

        this.selected_department.subscribe((newValue) => {
            if (newValue != null)
            {
                this.current_department_id(newValue.department_id)
                this.page.updateData()
            }
            else
            {
                this.current_department_id(null)
                this.page.updateData()
            }
        })

        this.selected_number_of_records.subscribe((newVal) => {
            this.current_page_size(newVal)
            this.current_page_number(1) // Reset to first page
            if (this.all_employee_data().length > 0) {
                this.updatePaginatedView()
            }
        })

        this.current_page_number.subscribe(() => {
            if (this.all_employee_data().length > 0) {
                this.updatePaginatedView()
            }
        })
    }

    page_click(page_number)
    {
        this.current_page_number(page_number)
    }

    updatePaginatedView()
    {
        const allData = this.all_employee_data()
        const pageSize = this.current_page_size()
        const currentPage = this.current_page_number()
        
        const startIndex = (currentPage - 1) * pageSize
        const endIndex = startIndex + pageSize
        
        const paginatedData = allData.slice(startIndex, endIndex)
        this.employee_habit_5_report(paginatedData)
        
        const totalRecords = allData.length
        this.total_records(totalRecords)
        this.page_count(Math.ceil(totalRecords / pageSize))
        
        const start = startIndex + 1
        const end = Math.min(endIndex, totalRecords)
        this.pagination_summary(`Showing ${start} to ${end} of ${totalRecords} records`)
    }
}

class ReportHabit5
{
    constructor(bindings)
    {
        this.bindings = bindings
        this.viewModel = new ReportHabit5ViewModel(this)
    }

    async init()
    {
        // check access to page
        if (await Utils.redirectOnAccessDenied('EmployeesHabit5Report')) return

        document.title = tr('Habit 5 Report')
        window.current_page_title(tr('Habit 5 Report'))

        let res = await Grape.fetches.getJSON('/api/record', {
            schema: 'savanna',
            table: 'v_employee_habit_5_report',
            limit: 1000000
        })

        if (res && res.records)
        {
            this.viewModel.all_employee_data(res.records)
            this.viewModel.current_page_number(1)
            this.viewModel.updatePaginatedView()
        }
    }

    updateData()
    {
        if (this.viewModel.current_department_id() != null) 
            this.updateReportData()
        else
            this.init() // Load all data when no department selected
    }

    async updateReportData()
    {
        this.viewModel.employee_habit_5_report([])
        this.viewModel.all_employee_data([])
        this.viewModel.loader(true)

        if (this.viewModel.current_department_id() != '' && 
            this.viewModel.current_department_id() != null && 
            this.viewModel.current_department_id() != undefined)
        {
            let res = await Grape.fetches.getJSON('/api/record', {
                schema: 'savanna',
                table: 'v_employee_habit_5_report',
                limit: 1000000,
                filter: [{ field: 'department_id', operator: '=', value: this.viewModel.current_department_id() }],
            })

            if (res && res.records)
            {
                this.viewModel.all_employee_data(res.records)
                this.viewModel.current_page_number(1)
                this.viewModel.updatePaginatedView()
                this.viewModel.loader(false)
            }
        }
        else
        {
            let res = await Grape.fetches.getJSON('/api/record', {
                schema: 'savanna',
                table: 'v_employee_habit_5_report',
                limit: 1000000,
            })

            if (res && res.records)
            {
                this.viewModel.all_employee_data(res.records)
                this.viewModel.current_page_number(1)
                this.viewModel.updatePaginatedView()
                this.viewModel.loader(false)
            }
        }
    }

    show_report_help()
    {
        Grape.dialog.open('Habit5ReportHelp', {} )
    }

    async download_clicked(v, e)
    {
        try {
            // Use all employee data for download
            const allData = this.viewModel.all_employee_data()
            
            if (allData && allData.length > 0)
            {
                // Temporarily update the observable with all data
                let original_data = this.viewModel.employee_habit_5_report()
                this.viewModel.employee_habit_5_report(allData)

                // Wait for DOM to update
                await new Promise(resolve => setTimeout(resolve, 100))

                let csv_string = await Utils.table_to_csv(document.getElementById('employee_habit_5_report'))

                // Restore original paginated data
                this.viewModel.employee_habit_5_report(original_data)

                if (csv_string === null || csv_string === undefined || csv_string === '')
                    return

                let blob = new Blob([csv_string], { type: 'text/csv;charset=utf-8;' })
                let link = document.createElement('a')

                link.href = URL.createObjectURL(blob)
                link.setAttribute('download', 'employee_habit_5_report.csv')

                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            }
            else
            {
                Grape.alerts.alert({ 
                    type: 'error', 
                    title: tr('No Data'), 
                    message: tr('There is no data to download.') 
                })
            }
        }
        catch (error)
        {
            console.error('Error downloading report:', error)
            Grape.alerts.alert({ 
                type: 'error', 
                title: tr('Error'), 
                message: tr('An error occurred while downloading the report.') 
            })
        }
    }
}

export default {
    route: '[/]report/habit_5_report',
    page_class: ReportHabit5,
    template: template,
    template_filename: 'translation/habit_5_report',
}